import styled from 'styled-components';
import { Currency } from '../../ui/ItemCard/styled';

export const PriceValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  ${Currency} {
    margin: 0;
  }

  svg {
    margin: 0;
  }
`;

export const SearchResultMapContainer = styled.div<{
  $markersLoading: boolean;
}>`
  opacity: ${({ $markersLoading }) => ($markersLoading ? 0.9 : 1)};
  transition: opacity 0.2s ease-in-out;
`;
